<template>
  <div class="sku-detail-body">
    <div class="sku-detail-product">
      <div>
        <span>商品（SKU）</span>
        <strong>{{ skuCode }}</strong>
        <b>{{ skuName }}</b>
      </div>
    </div>

    <section class="sku-manual-period-panel">
      <div class="sku-manual-period-title">
        <strong>人工配置发货周期</strong>
        <span>来源：SKU固定发货周期配置</span>
      </div>

      <div class="sku-manual-period-grid">
        <div>
          <span>配置发货周期</span>
          <b>{{ fixedCycle }}</b>
        </div>
        <div>
          <span>生效时间</span>
          <b>{{ effectivePeriod }}</b>
        </div>
        <div>
          <span>配置人</span>
          <b>{{ operatorName }}</b>
        </div>
        <div>
          <span>配置更新时间</span>
          <b>{{ updatedTime }}</b>
        </div>
      </div>

      <p>
        该 SKU 在上述生效时间内直接采用人工配置的发货周期，不再展示产品和包件计算明细。
      </p>
    </section>
  </div>
</template>

<script>
import { hasCycle, periodText } from '../model'

export default {
  name: 'SkuFixedPeriodDetail',
  props: {
    detail: {
      type: Object,
      required: true
    }
  },
  computed: {
    skuCode () {
      return this.detail.skuCode || this.detail.goodsCode || '—'
    },
    skuName () {
      return this.detail.skuName || this.detail.goodsName || '—'
    },
    fixedCycle () {
      const value = this.firstValue([
        'fixedCycle',
        'fixedDeliveryCycle',
        'fixedSendCycle',
        'fixedSendDeliveryCycle',
        'fixedPeriod'
      ])

      return periodText(value)
    },
    effectivePeriod () {
      return this.dateText(this.detail.fixedSendStartDate)
    },
    operatorName () {
      return this.detail.fixedSendOperatorName || '—'
    },
    updatedTime () {
      return this.dateText(this.detail.fixedSendUpdatedTime)
    }
  },
  methods: {
    firstValue (fields) {
      const field = fields.find(name => hasCycle(this.detail[name]))

      return field ? String(this.detail[field]) : ''
    },
    dateText (value) {
      if (!hasCycle(value)) {
        return '—'
      }

      const text = String(value)

      if (text.startsWith('9999-12-31')) {
        return '长期生效'
      }

      return text.replace('T', ' ')
    }
  }
}
</script>

<style scoped>
.sku-detail-body {
  color: #303133;
  font-size: 14px;
  line-height: 1.6;
}

.sku-detail-product {
  padding-bottom: 20px;
  border-bottom: 1px solid #ebeef5;
}

.sku-detail-product div {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}

.sku-detail-product span {
  color: #909399;
}

.sku-detail-product strong {
  color: #303133;
  font-size: 16px;
}

.sku-detail-product b {
  font-weight: 400;
}

.sku-manual-period-panel {
  margin-top: 20px;
  padding: 20px;
  background: #f4faf9;
  border: 1px solid #d8eee4;
  border-radius: 4px;
}

.sku-manual-period-title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 16px;
  border-bottom: 1px solid #d8eee4;
}

.sku-manual-period-title strong {
  color: #138f77;
  font-size: 16px;
}

.sku-manual-period-title span {
  color: #67a892;
}

.sku-manual-period-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px 32px;
  padding: 20px 0;
}

.sku-manual-period-grid div {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.sku-manual-period-grid span {
  color: #909399;
}

.sku-manual-period-grid b {
  color: #303133;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.sku-manual-period-panel p {
  margin: 0;
  padding-top: 16px;
  color: #606266;
  border-top: 1px solid #d8eee4;
  overflow-wrap: anywhere;
}
</style>
